export default __webpack_public_path__ + "static/media/magnifying.d3739d03.svg";